import { render } from "./ConnectAccount.vue?vue&type=template&id=755412be"
import script from "./ConnectAccount.vue?vue&type=script&lang=js"
export * from "./ConnectAccount.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Song\\Documents\\Fun\\snapshot\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__